import { forwardRef, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormsApi } from '@api/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return FormsComponent; }),
    multi: true
};
var FormsComponent = /** @class */ (function () {
    function FormsComponent(fuseTranslationLoaderService, formsApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.formsApi = formsApi;
        this.appearance = 'outline';
        this.forms = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.options = {
            limit: 25,
            offset: 0,
            orderBy: 'name_asc'
        };
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        if (this.required) {
            this.inputValue.setValidators(ValidateAutocomplete);
        }
    }
    FormsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.disabled) {
            this.inputValue.disable();
        }
        this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            _this.forms = [];
            if (value) {
                _this.searchForms(value);
            }
        });
    };
    FormsComponent.prototype.ngOnChanges = function (changes) {
        for (var propertyName in changes) {
            if (propertyName === 'disabled') {
                this.disabled = changes[propertyName].currentValue;
                if (this.disabled) {
                    this.inputValue.disable();
                }
                else {
                    this.inputValue.enable();
                }
            }
        }
    };
    FormsComponent.prototype.searchForms = function (searchTerm) {
        var _this = this;
        this.loading = true;
        this.formsApi
            .search({ name_contains: searchTerm && searchTerm.name ? searchTerm.name : searchTerm }, {
            orderBy: this.options.orderBy,
            limit: this.options.limit,
            offset: this.options.offset,
        })
            .subscribe(function (result) {
            _this.loading = false;
            _this.forms = result.items;
        });
    };
    FormsComponent.prototype.writeValue = function (formSelected) {
        var _this = this;
        if (formSelected) {
            this.formsApi.searchOne(formSelected.id).subscribe(function (form) {
                _this.selectedForm = form;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectForm();
        }
    };
    FormsComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    FormsComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    FormsComponent.prototype.setSelectedForm = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedForm = this.forms.find(function (form) { return form.id === _this.inputValue.value.id; });
            this.onChange(this.inputValue.value);
            this.inputValue.setErrors(null);
        }
    };
    FormsComponent.prototype.deselectForm = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedForm = null;
        this.inputValue.setErrors(null);
    };
    return FormsComponent;
}());
export { FormsComponent };
